import { render, staticRenderFns } from "./UserImport.vue?vue&type=template&id=53ea2c5d"
import script from "./UserImport.vue?vue&type=script&lang=js"
export * from "./UserImport.vue?vue&type=script&lang=js"
import style0 from "./UserImport.vue?vue&type=style&index=0&id=53ea2c5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports